/* GemHub Cart Drawer Fix v7 — 2026-10-07
   v7: Google merchant badge iframe (#google-merchantwidget-iframe-wrapper, full-viewport, z-index 2147483647,
   appended to <body> after the drawer) sat on top of the cart drawer on mobile and swallowed taps on the
   Checkout button. Hide it while the drawer is open.
   v6: move the drawer to <body> and keep it there, independent of section ids. */
(function () {
  'use strict';
  if (window.__ghCartFixV6) return;
  window.__ghCartFixV6 = true;

  try {
    var st = document.createElement('style');
    st.id = 'gh-cart-fix-merchant-widget';
    st.textContent = 'body:has(#shopify-snippet-cart.menu-open) #google-merchantwidget-iframe-wrapper,body:has(#shopify-snippet-cart.menu-open) #merchantwidgetiframe{display:none!important;pointer-events:none!important}';
    document.head.appendChild(st);
  } catch (e) {}

  function relocate() {
    var drawer = document.getElementById('cart_drawer');
    if (!drawer) return false;
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
    var panel = document.getElementById('shopify-snippet-cart');
    if (panel) {
      panel.style.setProperty('position', 'fixed', 'important');
      panel.style.setProperty('top', '0', 'important');
      panel.style.setProperty('right', '0', 'important');
      panel.style.setProperty('height', '100vh', 'important');
      panel.style.setProperty('height', '100dvh', 'important');
      panel.style.setProperty('z-index', '2147483647', 'important');
    }
    var overlay = document.getElementById('cart_overlay');
    if (overlay) {
      overlay.style.setProperty('position', 'fixed', 'important');
      overlay.style.setProperty('inset', '0', 'important');
      overlay.style.setProperty('z-index', '2147483646', 'important');
    }
    var inner = document.getElementById('Details-cart-drawer-container');
    if (inner) {
      inner.style.setProperty('height', '100%', 'important');
      inner.style.setProperty('max-height', '100vh', 'important');
      inner.style.setProperty('max-height', '100dvh', 'important');
      inner.style.setProperty('overflow-y', 'auto', 'important');
    }
    return true;
  }

  function init() {
    relocate();
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.id === 'cart_drawer' || (n.querySelector && n.querySelector('#cart_drawer'))) {
            relocate();
            return;
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[href*="/cart"], [onclick*="cart_drawer"], .header__icon--cart, #cart-icon-bubble, [name="add"], .gh-sticky-atc__btn');
      if (t) relocate();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', relocate);
  setTimeout(relocate, 500);
})();
